@if (notifications$ | async; as notifications) {
  <div
    *flexyooLet="isImpersonated$ | async as isImpersonated"
    class="notifications-sidebar-wrapper"
    [style.border-color]="wls.primaryColor"
  >
    <div class="notifications-sidebar-body">
      @if (hrAlertsCount$ | async) {
        <app-hr-alerts-block [hrAlerts]="hrAlerts$ | async"></app-hr-alerts-block>
      }
      <div class="notifications-block">
        @for (notif of notifications; track notif.Id) {
          <div class="notification-item">
            <mat-icon class="notification-item__icon" [svgIcon]="notif.Icon"></mat-icon>
            <span class="notification-item-title">
              @if (hasRedirect(notif.RedirectPage, notif.Type, notif.TextEn) && !isImpersonated) {
                <button class="redirect-button" mat-button (click)="navigateByUrl(notif)">
                  <span class="notification-item-title__text">{{
                    notif
                      | flexyooLocalizedName: translateService.currentLang : textTranslateSelector
                  }}</span>
                </button>
              } @else {
                <span class="notification-item-title__text">{{
                  notif | flexyooLocalizedName: translateService.currentLang : textTranslateSelector
                }}</span>
              }
              <span>{{ notif.CreatedDate | date: 'dd/MM/yyyy' }}</span>
            </span>
            <span
              [matTooltip]="'notifications-center.proxy-mode-tooltip-read' | translate"
              [matTooltipDisabled]="!isImpersonated"
            >
              <mat-checkbox
                [checked]="selectedNotifications.has(notif.Id)"
                [disabled]="isImpersonated"
                (change)="selectNotification($event, notif)"
              ></mat-checkbox>
            </span>
          </div>
        }
        @if (!notifications.length) {
          <div class="notifications-sidebar-empty-placeholder">
            {{ 'notifications-center.empty-sidebar-placeholder' | translate }}
          </div>
        }
      </div>
    </div>

    <div *flexyooLet="isSilentModeEnabled$ | async as isSilent" class="notifications-actions-block">
      <button
        matIconButton
        matSuffix
        [matTooltip]="'notifications-center.actions.silent-mode' | translate"
        (click)="toggleSilentMode(isSilent)"
      >
        <mat-icon [svgIcon]="isSilent ? 'fo-bell-off' : 'fo-bell'"></mat-icon>
      </button>
      <div class="notifications-actions">
        <span
          [matTooltip]="'notifications-center.proxy-mode-tooltip-read' | translate"
          [matTooltipDisabled]="!isImpersonated"
        >
          <button
            matButton="outlined"
            [disabled]="!notifications?.length || isImpersonated || !selectedNotifications.size"
            (click)="readNotifications()" class="fo-color-secondary"
          >
            {{ 'notifications-center.actions.read' | translate }}
          </button>
        </span>
        <button matButton="filled" (click)="proceedToList()">
          {{ 'notifications-center.actions.to-list' | translate }}
        </button>
      </div>
    </div>
  </div>
}
